import {backend} from '../../backend.js';

export default {
    namespaced: true,
    state: {
        authenticated: false,
        username: '',
        reception: false,
        remoteUser: '',
        company: '',
        rfid: '',
        isAdmin: false,
    },
    getters: {
        authenticated(state) {
            return state.authenticated;
        },
        username(state) {
            return state.username;
        },
        reception(state) {
            return state.reception;
        },
        remoteUser(state) {
            return state.remoteUser;
        },
        company(state) {
            return state.company;
        },
        rfid(state) {
            return state.rfid;
        },
        isAdmin(state) {
            return state.isAdmin;
        },
        apps(state, getters) {
            return [
                {
                    name: 'ia',  // these names should also appear in constants.js in APP_NAMES array
                    displayName: 'InternalApp',
                    authorized: getters.authenticated,
                    isAdmin: getters.isAdmin,
                    href: '/ia',
                },
            ]
        },
    },
    actions: {
        getAuthentication({commit}) {
            return backend.checkStatus()
                .then((response) => {
                    let username = response.data.authenticated ? response.data.username : '';
                    let reception = response.data.authenticated ? response.data.reception : false;
                    let company = response.data.authenticated ? response.data.company : '';
                    let remoteUser = response.data.remote_user ? response.data.remote_user : '';
                    let isAdmin = response.data.authenticated ? response.data.is_admin : false;
                    commit('setAuthenticated', response.data.authenticated);
                    commit('setUsername', username);
                    commit('setReception', reception);
                    commit('setCompany', company);
                    commit('setRemoteUser', remoteUser);
                    commit('setAdmin', isAdmin);
                });
        },
        login({commit}, payload) {
            return backend.login(payload.username, payload.password)
                .then((response) => {
                    commit('setAuthenticated', true);
                    commit('setReception', response.data.reception);
                    commit('setUsername', response.data.username);
                    commit('setAdmin', response.data.is_admin);
                    if (response.data.hasOwnProperty('remote_user'))
                        commit('setRemoteUser', response.data.remote_user);
                    if (response.data.hasOwnProperty('company'))
                        commit('setCompany', response.data.company);
                });
        },
        logout({commit, dispatch}) {
            return backend.logout()
                .then(() => {
                    commit('setAuthenticated', false);
                    commit('setReception', false);
                    commit('setUsername', '');
                    commit('setRemoteUser', '');
                    commit('setCompany', '');
                    commit('setRFID', '');
                    commit('setAdmin', false);
                    dispatch('ia/setCurrentReport', null, { root: true });
                });
        }
    },
    mutations: {
        setAuthenticated(state, authenticated) {
            state.authenticated = authenticated;
        },
        setUsername(state, username) {
            state.username = username;
        },
        setReception(state, reception) {
            state.reception = reception;
        },
        setCompany(state, company) {
            state.company = company;
        },
        setRemoteUser(state, remoteUser) {
            state.remoteUser = remoteUser;
        },
        setRFID(state, rfid) {
            state.rfid = rfid;
        },
        setAdmin(state, isAdmin) {
            state.isAdmin = isAdmin;
        },
    },
}



// WEBPACK FOOTER //
// ./app/store/modules/auth.js